const StepActions = {
  NEXT: 1,
  BACK: 2,
  SPECIFIC: 3,
};

export default StepActions;
